// export const Socket_URL = 'http://localhost:8080'
export const Socket_URL = 'https://real-time-location-sharing-app.onrender.com'